module.exports = __webpack_public_path__ + "static/scale-model-of-jack-london's-cabin-in-oakland-california-28e02362df4a99d527675f7197727a84.png";